import { render, staticRenderFns } from "./DataAreaComponent.vue?vue&type=template&id=b562446a&scoped=true"
import script from "./DataAreaComponent.vue?vue&type=script&lang=js"
export * from "./DataAreaComponent.vue?vue&type=script&lang=js"
import style0 from "./DataAreaComponent.vue?vue&type=style&index=0&id=b562446a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b562446a",
  null
  
)

export default component.exports